import React, { useState, useEffect, useRef } from 'react';
import { HelpModalBody } from './HelpModalBody';
import { i18n } from '../../i18n/translate';
import { copyTextFromElement } from '../../utils/CopyUtil';
import { getOS } from '../../utils';

interface UserData {
  attributes?: object | unknown;
}
interface Props {
  helpMessage: string;
  helpMessageEnabled: boolean;
  isFoundry: boolean;
  showHelpModal: boolean;
  toggleHelpModal: () => void;
  user?: UserData;
  copyDone: boolean;
}

export const HelpModal: React.FC<Props> = ({
  helpMessage,
  helpMessageEnabled,
  isFoundry,
  showHelpModal,
  toggleHelpModal,
  user,
  copyDone,
}) => {
  const containerRef = useRef(null);
  const [copySuccess, setCopySuccess] = useState<boolean | null>(null);
  const [isLoading, setLoading] = useState(true);

  useEffect((): void => {
    // make sure the DOM node is assigned to the containerRef.current property
    if (isLoading && containerRef?.current) setLoading(false);
  }, [isLoading]);

  const copyToClipboard = (): void => {
    const success: boolean = copyTextFromElement('#help-modal-info', document.getElementById('help-modal'));
    setCopySuccess(success);
    if (copyDone === false) {
      copyDone = true;
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  const getUserTypes = ({
    user_types,
    rule_sets,
  }: {
    user_types?: Record<string, unknown>;
    rule_sets?: Array<{ label: string }>;
  }): string => {
    let values: string[] = [];
    if (user_types) {
      values = Object.keys(user_types);
    } else if (rule_sets) {
      values = rule_sets.map(rs => rs.label);
    }
    return values.join(', ');
  };

  const cookieEnabled: boolean =
    typeof window !== 'undefined' && window.navigator.cookieEnabled ? i18n.t('enabled') : i18n.t('disabled');
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const userData = user?.attributes || user;

  return (
    <div ref={containerRef} className="foundry">
      <HelpModalBody
        cookieEnabled={cookieEnabled}
        /* @ts-ignore */
        copySuccess={copySuccess}
        copyToClipboard={copyToClipboard}
        currentUrl={currentUrl}
        getOS={getOS}
        /* @ts-ignore */
        getUserTypes={getUserTypes}
        helpMessage={helpMessage}
        helpMessageEnabled={helpMessageEnabled}
        isFoundry={isFoundry}
        ref={!isLoading ? containerRef.current : null}
        showHelpModal={showHelpModal}
        toggleHelpModal={toggleHelpModal}
        /* @ts-ignore */
        userData={userData}
      />
    </div>
  );
};
